import React from "react";
import "./DefaultLoader.scss";

const DefaultLoader = () => {
  return (
    <div className="defaultloader">
      <span className="loader"></span>
    </div>
    
  );
};

export default DefaultLoader;
